const StripeKey = document.head.querySelector('[name="stripe-key"]').content

export default StripeKey
